<template>
  <div class="chart" :class="{ small: isSmall }">
    <strong> Kvantpunkt </strong>

    <img
      src="https://v.postimees.ee/graafikud/2023/keemiapreemia/kvantpunkt.png"
      alt="🪩"
    />

    <section>
      Kvantpunktiks on nanomõõtkavas osake, mis on jalgpallist sama palju kordi
      väiksem, kui palju kordi on jalgpall väiksem Maast. Kvantpunkt on
      kristall, mis koosneb vaid mõnedest tuhandetest aatomitest. Kvantpunktide
      iselaadsed omadused johtuvad asjaolust, et selle pinnal on selle sisemuses
      olevate aatomitega samas suurusjärgus aatomeid.
    </section>

    <footer>
      Allikas: Johan Jarnestad/Rootsi Kuninglik Teaduste Akadeemia
    </footer>
  </div>
</template>

<style>
.device-phone #keemiapreemia {
  margin-left: calc(var(--root-padding) * -1);
  margin-right: calc(var(--root-padding) * -1);
}
</style>

<style scoped>
.chart {
  font-family: GT Eesti, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: var(--text-color);

  font-size: 16px;
  line-height: 1;
  word-spacing: 0;

  width: 100%;
  display: flex;
  flex-direction: column;

  background-color: var(--light);
  border-radius: 3px;

  box-sizing: border-box;
  padding: 2em;

  overflow: hidden;

  --container-width: v-bind(containerWidth + "px");
}

.small.chart,
.device-phone .chart {
  padding: var(--root-padding);
  border-radius: 0;

  font-size: 13px;
}

.chart > strong {
  font-size: 2em;
  line-height: 1.15;
  text-wrap: balance;

  margin-bottom: 0.25em;
}

.chart.small > strong {
  font-size: 1.55em;
}

.chart img {
  width: 100%;
  margin: 0.5em 0;
}

section,
footer {
  font-weight: 300;
  line-height: 1.33;
}

.dark-theme section,
.dark-theme footer {
  font-weight: 400;
}

section {
  font-size: 1.25em;
}

footer {
  font-size: 0.8em;
  margin-top: 1em;
  text-wrap: balance;
  /*  text-align: right;*/
}
</style>

<script setup>
import { ref, computed, onMounted, onUnmounted, nextTick, inject } from "vue";

// container element
const containerElement = inject("containerElement");
const containerWidth = ref(0);
const isSmall = computed(() => {
  return containerWidth.value < 550;
});

/**
 *
 */
function onResize() {
  containerWidth.value = containerElement.clientWidth;
}

// ***

onMounted(async () => {
  window.addEventListener("resize", onResize);
  onResize();
  nextTick(onResize);
  window.setTimeout(onResize, 1500);
});

onUnmounted(() => {
  window.removeEventListener("resize", onResize);
});
</script>
